import React from 'react';
import { FaTrash, FaTimes } from 'react-icons/fa';
import css from './DeleteModal.module.css';

interface DeleteModalProps {
  fileCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  fileCount,
  onConfirm,
  onCancel
}) => {
  return (
    <div className={css.modalOverlay}>
      <div className={css.modal}>
        <button className={css.closeButton} onClick={onCancel}>
          <FaTimes />
        </button>
        
        <div className={css.modalHeader}>
          <FaTrash className={css.deleteIcon} />
          <h2>Delete Files</h2>
        </div>
        
        <div className={css.modalContent}>
          <p>
            You are about to delete <strong>{fileCount} file{fileCount !== 1 ? 's' : ''}</strong>.
          </p>
          <p>
            This action cannot be undone. Are you sure you want to proceed?
          </p>
        </div>
        
        <div className={css.modalFooter}>
          <button 
            className={css.cancelButton} 
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className={css.confirmButton} 
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal; 